import { c as _c } from "react/compiler-runtime";
import type { Vendor } from '@cruz-com/lookup';
import { CloseButton, Popover, PopoverButton, PopoverPanel } from '@headlessui/react';
import _ from 'lodash';
import NextLink from 'next/link';
import { useMemo } from 'react';
import { BiDotsHorizontalRounded } from 'react-icons/bi';
import { BsChatSquareText } from 'react-icons/bs';
import { VscCallOutgoing } from 'react-icons/vsc';
import { twMerge } from 'tailwind-merge';
import { LeadTypeEnum, lkpLeadList, trackingLocationPhoneClick } from '@/lib';
import { useGlobalStore } from '@/store/provider';
type Props = {
  d: Vendor.Location;
  vehicle_id: string;
  vehicle_title: string;
  showRequestHistoryReport: boolean;
};
const btnPopoverStyle = twMerge('flex items-center justify-center gap-x-1 p-3 truncate w-full', 'focus-visible:outline-none hover:bg-zinc-100 dark:hover:bg-zinc-800', 'data-active:bg-zinc-100', 'dark:data-active:bg-zinc-900');
export const DealerInfo = t0 => {
  const $ = _c(34);
  const {
    d,
    showRequestHistoryReport,
    vehicle_id,
    vehicle_title
  } = t0;
  const {
    setLead
  } = useGlobalStore(_temp);
  let t1;
  if ($[0] !== d) {
    t1 = d || {};
    $[0] = d;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    name,
    city,
    state_abbr,
    zip_code,
    distance,
    phone,
    place,
    dealer_url
  } = t1;
  const locName = name || place?.display_name || "";
  let t2;
  if ($[2] !== showRequestHistoryReport) {
    t2 = showRequestHistoryReport ? lkpLeadList : _.filter(lkpLeadList, _temp2);
    $[2] = showRequestHistoryReport;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const leadTypeList = t2;
  let t3;
  if ($[4] !== leadTypeList || $[5] !== setLead || $[6] !== vehicle_id || $[7] !== vehicle_title) {
    t3 = <Popover as="div" className="relative">{() => <><PopoverButton className={btnPopoverStyle} aria-label="Check Availability Options"><BsChatSquareText className="mr-2 size-4 min-w-4" aria-hidden="true" />Check Availability<BiDotsHorizontalRounded className="size-5" aria-hidden="true" /></PopoverButton><PopoverPanel anchor="top end" transition={true} modal={false} className="menu-items -mt-px w-[220px] rounded-lg border"><section className="bg-zinc-700 p-2 dark:bg-zinc-500" aria-label="Contact Seller Menu"><h3 className="mb-1 px-4 text-lg! font-semibold text-white dark:text-zinc-950">Contact Seller<div className="w-5 border-t-3 border-red-600" aria-hidden="true" /></h3><div className="divide-y rounded border bg-white dark:bg-zinc-900" role="menu">{_.map(leadTypeList, t4 => {
                const {
                  id,
                  name: name_0
                } = t4;
                return <CloseButton as="button" key={`dml-${id}`} type="button" role="menuitem" onClick={() => {
                  setLead({
                    type: id,
                    vehicle_id,
                    vehicle_title
                  });
                }} className="menu-item w-full px-4! py-2.5!">{name_0}</CloseButton>;
              })}</div></section></PopoverPanel></>}</Popover>;
    $[4] = leadTypeList;
    $[5] = setLead;
    $[6] = vehicle_id;
    $[7] = vehicle_title;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const contactMenu = t3;
  const t4 = dealer_url || "";
  let t5;
  if ($[9] !== locName) {
    t5 = <h3 className="m-0! truncate p-0! text-base/6! font-semibold! md:text-sm!">{locName}</h3>;
    $[9] = locName;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== distance) {
    t6 = distance && <span className="ml-1">({distance.toLocaleString()} mi. away)</span>;
    $[11] = distance;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== city || $[14] !== state_abbr || $[15] !== t6 || $[16] !== zip_code) {
    t7 = <address className="m-0 truncate text-sm/6 font-light not-italic">{city}, {state_abbr} {zip_code}{t6}</address>;
    $[13] = city;
    $[14] = state_abbr;
    $[15] = t6;
    $[16] = zip_code;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== t5 || $[19] !== t7) {
    t8 = <div className="truncate w-full px-4 py-2.5 hover:bg-zinc-100 dark:hover:bg-zinc-800">{t5}{t7}</div>;
    $[18] = t5;
    $[19] = t7;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  let t9;
  if ($[21] !== t4 || $[22] !== t8) {
    t9 = <NextLink hrefLang="en" href={t4} className="block">{t8}</NextLink>;
    $[21] = t4;
    $[22] = t8;
    $[23] = t9;
  } else {
    t9 = $[23];
  }
  let t10;
  if ($[24] !== d || $[25] !== locName || $[26] !== phone) {
    t10 = phone ? <a href={`tel:${phone}`} onClick={() => trackingLocationPhoneClick(d._id as string)} rel="noreferrer" aria-label={`Call ${locName} at ${phone}`} className="flex items-center justify-center gap-x-3 truncate p-3 hover:bg-zinc-100 dark:hover:bg-zinc-800"><VscCallOutgoing className="size-4" aria-hidden="true" />{phone}</a> : <div className="flex items-center justify-center gap-x-3 truncate p-3 text-zinc-400"><VscCallOutgoing className="size-4" aria-hidden="true" />N/A</div>;
    $[24] = d;
    $[25] = locName;
    $[26] = phone;
    $[27] = t10;
  } else {
    t10 = $[27];
  }
  let t11;
  if ($[28] !== contactMenu || $[29] !== t10) {
    t11 = <section className="grid h-[42px] grid-cols-[43%_57%] divide-x border-t text-sm/6 font-normal dark:font-light" aria-label="Contact Options">{t10}{contactMenu}</section>;
    $[28] = contactMenu;
    $[29] = t10;
    $[30] = t11;
  } else {
    t11 = $[30];
  }
  let t12;
  if ($[31] !== t11 || $[32] !== t9) {
    t12 = <section className="border-t" aria-label="Dealership Information">{t9}{t11}</section>;
    $[31] = t11;
    $[32] = t9;
    $[33] = t12;
  } else {
    t12 = $[33];
  }
  return t12;
};
function _temp(state) {
  return state;
}
function _temp2(x) {
  return x.id !== LeadTypeEnum.RequestHistoryReport;
}